import CircularProgress from "@material-ui/core/es/CircularProgress/CircularProgress";
import axios from "axios/index";
import React from "react";
import './MessengerNavigation.scss';
import GoogleMapsIcon from "../../../resources/images/GoogleMapsIcon.png";
import WazeIcon from "../../../resources/images/WazeIcon.png";
import Button from "@material-ui/core/Button";
import Direction from "../../Utils/Direction/Direction";

export default class MessengerNavigation extends React.Component {
    constructor(props) {
        super(props);

        const clickedWazeAddresses = [];

        const savedclickedWazeAddressesRaw = localStorage.getItem('clickedWazeOrders');

        // If the device saved some data on the localstorage
        if (savedclickedWazeAddressesRaw) {
            // Parse the localstorage data
            const savedclickedWazeAddressesParsed = JSON.parse(savedclickedWazeAddressesRaw);

            // If the saved data is on this delivery group's id
            if (savedclickedWazeAddressesParsed.groupId === props.match.params.id && savedclickedWazeAddressesParsed.addresses)
                clickedWazeAddresses.push(...savedclickedWazeAddressesParsed.addresses);
        }

        this.state = {
            clickedWazeAddresses: clickedWazeAddresses
        };
    }

    injectOrdersToDeliveryOrders(deliveryOrders, orders) {
        return deliveryOrders.map(deliveryOrder => {
            return {...deliveryOrder, order: orders.find(order => order.id === deliveryOrder.order_id)}
        });
    }

    async queryGroupDetails(id) {
        const {data: deliveryGroup} = await axios.get('/api/v2a/deliveryGroup', {
            params: {
                id: id
            }
        });

        let {data: orders} = await axios.get('api/v2a/getOrders', {
            params: {
                bid: deliveryGroup.bid,
                orderIds: deliveryGroup.route.map(deliveryOrder => deliveryOrder.order_id)
            }
        });

        const deliveryGroupWithOrders = {
            ...deliveryGroup,
            route: this.injectOrdersToDeliveryOrders(deliveryGroup.route, orders)
        };

        const {data: business} = await axios.get('/api/v2a/getBusiness', {params: {bid: deliveryGroupWithOrders.bid}});

        if (deliveryGroupWithOrders)
            this.setState({
                deliveryGroup: deliveryGroupWithOrders,
                business: business
            });
    }

    componentDidMount() {
        if (this.props.match.params.id) {
            this.queryGroupDetails(this.props.match.params.id);
        }
    }


    getGoogleMapsUrl(business, group) {
        const waypoint_place_ids = group.route.map(deliveryOrder => deliveryOrder.order["place_id"]).join('%7C');
        const waypoints = group.route.map(deliveryOrder => deliveryOrder.order.address).join('%7C');
        const business_place_id = business["place_id"];
        const business_name = business.name;

        return `https://www.google.com/maps/dir/?api=1&destination=${business_name}&waypoints=${waypoints}&destination_place_id=${business_place_id}&travelmode=driving&waypoint_place_ids=${waypoint_place_ids}`
    }

    onGoogleMapsButtonClick() {
        const googleMapsUrl = this.getGoogleMapsUrl(this.state.business, this.state.deliveryGroup);

        // Redirect to the google maps link
        window.location.replace(googleMapsUrl);
    }

    onWazeButtonClick() {
        this.setState({
            selectedNavigationOption: this.state.selectedNavigationOption === "waze" ? undefined : "waze"
        })
    }

    getWazeUrl(address, location) {
        const encodedAddress = encodeURI(address);

        return `https://waze.com/ul?q=${encodedAddress}&ll=${location.lat},${location.lng}&navigate=yes`;
    }

    onWazeAddressClick(address, location) {
        // If the order id is not in the list of clicked waze deliveryOrders
        if (!this.state.clickedWazeAddresses.includes(address)) {
            // Add the order to the list
            const newClickedWazeAddresses = this.state.clickedWazeAddresses.concat([address]);

            this.setState({
                clickedWazeAddresses: newClickedWazeAddresses
            });

            // Save the deliveryOrders list in the localStorage
            const clickedWazeAddressesToSave = {
                groupId: this.props.match.params.id,
                addresses: newClickedWazeAddresses
            };

            localStorage.setItem("clickedWazeOrders", JSON.stringify(clickedWazeAddressesToSave));
        }

        const wazeUrl = this.getWazeUrl(address, location);

        // Redirect to the waze deep link
        window.location.replace(wazeUrl);
    }

    render() {
        return (
            <Direction direction="rtl">
                <div className="messenger-navigation">
                    {
                        !this.state.deliveryGroup ?
                            <CircularProgress/>
                            :
                            <div>
                                <div className="navigation-options-title">באיזו אפליקציה תרצה לנווט ?</div>
                                <div className="navigation-options">
                                    <div className="navigation-option">
                                        <Button variant="contained" onClick={this.onGoogleMapsButtonClick.bind(this)}>
                                            <img className="navigation-option-image" src={GoogleMapsIcon}/>
                                        </Button>
                                    </div>
                                    <div className="navigation-option">
                                        <Button variant="contained"
                                                color={this.state.selectedNavigationOption === 'waze' ? "primary" : "default"}
                                                onClick={this.onWazeButtonClick.bind(this)}>
                                            <img className="navigation-option-image" src={WazeIcon}/>
                                        </Button>
                                    </div>
                                </div>
                                <div
                                    className={'waze-addresses ' + (this.state.selectedNavigationOption === 'waze' ? 'waze-addresses-visible' : 'waze-addresses-hidden')}
                                >
                                    <div className="waze-addresses-title">כתובות לשילוח באמצעות Waze:</div>
                                    {
                                        this.state.deliveryGroup.route.map(deliveryOrder => {
                                            return <div key={`waze-address-${deliveryOrder["order_id"]}`}
                                                        className="waze-address">
                                                <Button fullWidth={true} variant="outlined"
                                                        color={this.state.clickedWazeAddresses.includes(deliveryOrder.order.address) ? "secondary" : "primary"}
                                                        onClick={this.onWazeAddressClick.bind(this, deliveryOrder.order.address, deliveryOrder.order.location)}>
                                                    {deliveryOrder.order.address}
                                                </Button>
                                            </div>
                                        })
                                    }
                                    <div className="waze-address waze-address-business">
                                        <Button fullWidth={true} variant="outlined"
                                                color={this.state.clickedWazeAddresses.includes(this.state.business.address) ? "secondary" : "primary"}
                                                onClick={this.onWazeAddressClick.bind(this, this.state.business.address, this.state.business.location)}>
                                            {`חזרה ל${this.state.business.name}`}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                    }
                </div>
            </Direction>
        );
    }
}